import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom';

import { ResultPage } from 'layouts';
import { wrapCreateBrowserRouterV7 } from 'sentry';

import * as routes from './routes';
import { setRouterNavigate } from './navigation';
import { publicRoutes } from './publicRoutes';
import { privateRoutes } from './privateRoutes';
import RootLayout from './RootLayout';

const createRouter = wrapCreateBrowserRouterV7(createBrowserRouter);

const router = createRouter(
  createRoutesFromElements(
    <Route
      element={<RootLayout />}
      errorElement={<ResultPage message="Something went wrong. Please refresh the page." />}
    >
      {publicRoutes}
      {privateRoutes}

      <Route path="*" element={<Navigate replace to={routes.home} />} />
    </Route>,
  ),
);

setRouterNavigate((to, options) => router.navigate(to, options));

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
